import React from 'react';

const PrintIcon_v2 = ({ className }: { className?: string }) => {
  // 00538F
  return (
    <svg
      className={className}
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5 8.31185V2.47852H15V8.31185" stroke="currentColor" />
      <path
        d="M5.00033 15.8125H3.33366C2.89163 15.8125 2.46771 15.6369 2.15515 15.3243C1.84259 15.0118 1.66699 14.5879 1.66699 14.1458V9.97917C1.66699 9.53714 1.84259 9.11322 2.15515 8.80066C2.46771 8.4881 2.89163 8.3125 3.33366 8.3125H16.667C17.109 8.3125 17.5329 8.4881 17.8455 8.80066C18.1581 9.11322 18.3337 9.53714 18.3337 9.97917V14.1458C18.3337 14.5879 18.1581 15.0118 17.8455 15.3243C17.5329 15.6369 17.109 15.8125 16.667 15.8125H15.0003"
        stroke="currentColor"
      />
      <path d="M15 12.4785H5V19.1452H15V12.4785Z" stroke="currentColor" />
    </svg>
  );
};

export default PrintIcon_v2;
